<template>
	<layout-admin>
		<header-general :company-data="company" />
		<app-banner :data="banner"/>
		<product-list />
	</layout-admin>
</template>

<script>
import appBanner from '@/components/commons/app-banner';
import headerGeneral from '@/components/commons/header';
import productList from '@/components/product/list';

function mounted() {
	this.loadData();
	this.fetchProducts();
}

async function loadData() {
	const { data: company } = await this.$http.get(
		`company/${process.env.COMPANY_CODE}/app/${process.env.APP_CODE}`);
	const newCompany = { ...company.data };
	newCompany.latitude = Number(company.data.latitude);
	newCompany.longitude = Number(company.data.longitude);
	this.company = { ...newCompany };
	this.$bus.$emit('get-company', this.company);
}

function data() {
	return {
		banner: {
			image: 'http://picture-controlinn.s3.amazonaws.com/svg/products-background.jpg',
			title: 'Nuestros Productos',
		},
		company: {},
	};
}

export default {
	name: 'page-products',
	components: {
		headerGeneral,
		appBanner,
		productList,
	},
	mounted,
	data,
	methods: {
		loadData,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/page-products.vue